import React, { useState } from 'react';
import { auth, functions } from '../firebase/firebase';
import { httpsCallable } from 'firebase/functions';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { logFunctionCall } from '../utils/performanceLogging';
import Footer from './Footer';

const Login = () => {
  const [entryPhrase, setEntryPhrase] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const authenticateUser = httpsCallable(functions, 'authenticateUser');
      const result = await logFunctionCall('authenticateUser', () => 
        authenticateUser({ entryPhrase })
      );
      if (result.data.isAuthenticated) {
        await signInWithEmailAndPassword(auth, result.data.email, entryPhrase);
      } else {
        throw new Error('Invalid entry phrase');
      }
    } catch (error) {
      console.error('Error during login:', error);
      setError("Oops! That didn't work. Please check your entry phrase or get in touch if you're stuck!");
    }
    setLoading(false);
  };

  return (
    <div 
      className="min-h-screen flex flex-col bg-cover bg-center"
      style={{ backgroundImage: "url('/images/11.jpg')" }}
    >
      <div className="flex-grow flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 bg-white bg-opacity-90 p-10 rounded-xl shadow-lg">
          <div>
            <h1 className="text-3xl font-bold text-center text-gray-900 mb-2">
              Welcome to Dominic and Florian's Berlin Home
            </h1>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleLogin}>
            <div>
              <label htmlFor="entry-phrase" className="sr-only">Entry phrase</label>
              <input
                id="entry-phrase"
                name="entry-phrase"
                type="password"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Entry phrase"
                value={entryPhrase}
                onChange={(e) => setEntryPhrase(e.target.value)}
              />
            </div>
            <div>
              <button
                type="submit"
                disabled={loading}
                className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${
                  loading ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-700'
                } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
              >
                {loading ? 'Please wait...' : 'Continue'}
              </button>
            </div>
          </form>
          {error && (
            <p className="mt-2 text-center text-sm text-red-600">{error}</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;